import { create } from "zustand";
import { persist } from "zustand/middleware";

// UI state that is not server data (PRD §7.3: view mode, selection, drawers).
type UIState = {
  railExpanded: boolean;
  drawerOpen: boolean;
  inspectorMonitorId: string | null;
  inspectorOpen: boolean;
  audible: boolean;
  paletteOpen: boolean;
  setPalette: (v: boolean) => void;
  toggleRail: () => void;
  toggleDrawer: () => void;
  inspect: (monitorId: string | null) => void;
  closeInspector: () => void;
  setAudible: (v: boolean) => void;
};

export const useUI = create<UIState>()(
  persist(
    (set) => ({
      railExpanded: true,
      drawerOpen: true,
      inspectorMonitorId: null,
      inspectorOpen: false,
      audible: false,
      paletteOpen: false,
      setPalette: (v) => set({ paletteOpen: v }),
      toggleRail: () => set((s) => ({ railExpanded: !s.railExpanded })),
      toggleDrawer: () => set((s) => ({ drawerOpen: !s.drawerOpen })),
      inspect: (monitorId) => set({ inspectorMonitorId: monitorId, inspectorOpen: monitorId !== null }),
      closeInspector: () => set({ inspectorOpen: false }),
      setAudible: (v) => set({ audible: v }),
    }),
    { name: "atlas-ui", partialize: (s) => ({ railExpanded: s.railExpanded, drawerOpen: s.drawerOpen, audible: s.audible }) },
  ),
);
